import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlexRow, HtmlVideoPlayer, MediumText, Modal } from '@guryou/html-components';
import { getVideoCourseFilesFeel, stateIsLoaded } from '@guryou/redux';
import MyCustomPreviewModal from 'modules/myVideos/MyCustomPreviewModal';
import MyImagePreview from 'modules/myVideos/MyImagePreview';
import { VideoCourseView } from 'modules/myVideos/UserVideoCourseFiles';

const VideoCourseFiles = ({ id, videoCourse }) => {
  const dispatch = useDispatch();
  const vcSelector = useSelector(state => state.videoCourses.videoCourseFiles);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      dispatch(getVideoCourseFilesFeel(id));
    }
  }, [dispatch, id]);

  if (!id || (stateIsLoaded(vcSelector) && !vcSelector.data)) {
    return (
      <FlexRow height="100vh">
        <MediumText>Oops, something went wrong!</MediumText>
      </FlexRow>
    );
  }
  const vfiles = (stateIsLoaded(vcSelector) && vcSelector?.data?.length && vcSelector.data) || [];

  return (
    <>
      <VideoCourseView vfiles={vfiles} videoCourse={videoCourse} vcSelector={vcSelector} allowPreview={false} />

      <Modal id="playVideoMedia" maxWidth="md">
        <HtmlVideoPlayer />
      </Modal>
      <Modal id="previewImage" maxWidth="lg">
        <MyImagePreview />
      </Modal>

      <Modal id="myCustomModal" maxWidth="lg">
        <MyCustomPreviewModal />
      </Modal>
    </>
  );
};

export default VideoCourseFiles;
